  import { Injectable } from "@angular/core";
  import { DashboardService } from "../dashboard.service";
  import { CommonService } from "../common.service";
  import { appSettings, errorMessages } from "../../settings";
  import * as moment from "moment";
  import {
    SignalRConnection
  } from "ng2-signalr";
  import { UserPreference } from "../../models/UserPreference";
  import { WidgethelperService } from "../widgethelper.service";
  import * as _ from 'lodash';

  @Injectable()
  export class ParcelshipmentpctService {
  
    private hub: SignalRConnection;
    labelSetting = {
      normal: {
        show: true,
        position: "outside",
        offset: [10, 0],
        textStyle: {
          fontSize: 18,
          fontFamily: "lato",
          color: "#ccc"
        }
      }
    };
  
    constructor(
      private _dashboardService: DashboardService,
      private _commonService: CommonService,
      private _widgetHelper: WidgethelperService
    ) { }
  
    chartOptions() {
      return {
        color:['#3398DB', '#DBB55E', '#fbb03b', '#f7931e', '#F27921', '#F25F1A', '#BF3C26', '#F2263C', '#8A26F2', '#7434F2', '#4333BF', '#6455F2', '#708AF2', '#7FB1F2', '#8DD6F2', '#4FFFE8', '#3EFFB1', '#d48265', '#91c7ae', '#597764', '#ca8622'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {            
            type: 'shadow'        
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },       
        legend: {
          type: 'scroll',
          data: [],
          top: '4%',
          textStyle: {
            color: "#fff"
          }
        },
        xAxis: {
          type: 'category',
          data: 'value',
          axisLabel: {
            interval: 0,
            color: "#fff",
            length: '100%',
            rotate: 25
          }         
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              interval: 0,
              length: "100%",
              rotate: 25,
              color: "#fff",
              formatter: '{value} %'
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            splitLine: {
              show: false
            },
          }
        ],
        series: [
          {
            name: 'Parcel Shipment %',
            type: 'bar',
            barWidth: '30',
            data: []
          }
        ]
      };
    }
  
    init(widget: any) {
      console.log("Parcel Shipment %");
      widget.dataLoaded = false;
      widget.errorMessage = "Retrieving records. Please wait...";
      let currentDateTime = moment()
        .toDate()
        .getTime();
      widget.Title = "Parcel Shipment %";
      widget.initcreationtime = currentDateTime;
      widget.widgetcreationtime = currentDateTime;
      if (!widget.hub) {
        widget.hub = this._dashboardService.startConnection();
      }
  
      widget.hub
        .start()
        .then(() => {
          console.log("Connection started!");
          widget.ConnectionId = widget.hub.id;
          let userPref: UserPreference = this._commonService.getUserPreference();
          widget.hub.listenFor("broadcastParcelShipmentPct").subscribe(
            (result: any) => {
              console.log("broadcastParcelShipmentPct", result);
  
              let resultwid;
              let resultcreationtime;
              let lastUpdatedTime;
  
              if (result && result.length > 0) {
                //console.log(result[0].IsNoDataFound);
                widget.IfNoDataFound = result[0].IsNoDataFound;
                resultwid = result[0].widgetid;
                resultcreationtime = result[0].widgetcreationtime;
                lastUpdatedTime = result[0].LastUpdateTime;
              }
              else {
                widget.errorMessage = errorMessages.noWidgetData;
              }

              if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
                let Report_Periods = [];
                let Report_Periods_value = [];
                if (widget.IfNoDataFound == null) {
                  widget.errorMessage = "Retrieving records. Please wait...";
                }
                else{
                  widget.dataLoaded = false;
                  widget.chartOptions = this.chartOptions();
                  widget.errorMessage = null;
                  
                  for (let i = 0; i < result.length; i++) {
                    let rptdate =  result[i].REPORT_DATE;
                    // rptdate = this._commonService.formatDate(
                    //   result[i].REPORT_DATE,
                    //   appSettings.chartDayHrFormat2
                    // );
                    if (rptdate != '' && Report_Periods_value.indexOf(rptdate) == -1) {
                      Report_Periods_value.push(rptdate);
                    }
                  }
                  
                  //let Report_Periods = ['MON','TUE','WED','THU','FRI','SAT','SUN'];
                  let shipmentoption = Object.keys(result[0]);

                  shipmentoption.forEach(element => {
                    if(element.toLowerCase().search('pct')!= -1){
                      let values = [];
                      Report_Periods_value.forEach(day => {
                        let row = result.find(x=>x.REPORT_DATE == day)
                        if(row)
                          values.push(row[element]);
                      });                      
                      
                      addDataSeries(values, element ,'line' ,'1');
                    }                  
                  });
                  Report_Periods_value.forEach(element => {
                    let rptdate = this._commonService.formatDate(
                      element,
                      appSettings.chartDayFormat
                    );
                    Report_Periods.push(rptdate);
                  });
                  widget.chartOptions.xAxis.data = Report_Periods;

                  widget.chartOptions.yAxis.max = 100;
                  widget.chartOptions.tooltip.formatter = this.tooltipWithPct;
                }
              }


              function addDataSeries(response, name, chartType, stackBy = '') {
               
                widget.chartOptions.legend.data.push(_.startCase(name.replace('_', ' ').replace('PCT','').toLowerCase()));
      
                widget.chartOptions.series.push({
                  name: _.startCase(name.replace('_', ' ').replace('PCT','').toLowerCase()),
                  type: chartType,
                  barWidth: 30,
                  areaStyle: {},
                  barGap: '5%',
                  stack: stackBy,      
                  shadow: false,
                  data: response,
                });
              }

              widget.dataLoaded = true;
              this._commonService.lastUpdatedTime = lastUpdatedTime;
            },
            err => {
              console.log("listenFor broadcastParcelShipmentPct error", err);
            }
          );
  
          let widgetData: any = {};
          widgetData = this._commonService.deepClone(widget.widgetsettings);
          widgetData.WidgetType = "PARCELSHIPMENTPCT";
          widgetData.CreatedTime = widget.widgetcreationtime;
          widgetData.CustomerId = userPref.CustomerId;
          widgetData.Facility = userPref.FacilityId;
          widgetData.LastUpdate = "31-Jan-2017";
          widgetData.WidgetId = widget.widgetId;
  
          widgetData.ConnectionId = widget.hub.id;
          widget.hub
            .invoke("GetWidgetData", widgetData)
            .then(data => {
              console.log('GetWidgetData', data);
            })
            .catch(err => {
              console.log("Error GetWidgetData", err);
            });
        })
        .catch(err => {
          console.log("Error while establishing connection", err);
        });
    }
  
    remove(widget: any){
      this._widgetHelper.remove(widget)  
    }
    reload(widget: any) {
      this._widgetHelper.reload(widget)
    }
 
    tooltipWithPct(params): string {
      let tip: string = '';
      if (Array.isArray(params) && params.length > 0) {
        tip = params[0].axisValueLabel + '</br>'
        params.forEach(function (item) {
          tip = tip + '<span style="display:inline-block;margin-right:5px;'
            + 'border-radius:10px;width:9px;height:9px;background-color:'
            + item.color + ';"></span>' + item.seriesName + ' : ' + item.data.toFixed(2) + '%</br>';
          let val = parseFloat(item.data[1]);
        });
      }
      return tip;
    }
  }
  


// WEBPACK FOOTER //
// ./src/app/services/widgets/parcelshipmentpct.service.ts